import { render, staticRenderFns } from "./Dasboard.vue?vue&type=template&id=0c655086&scoped=true"
import script from "./Dasboard.vue?vue&type=script&lang=js"
export * from "./Dasboard.vue?vue&type=script&lang=js"
import style0 from "./Dasboard.vue?vue&type=style&index=0&id=0c655086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c655086",
  null
  
)

export default component.exports